// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './Card.scss';
import { Link } from 'react-router-dom';
import { observable } from 'mobx';
import Request from '../../../../api/Request';
import CircleLoader from '../../../Util/CircleLoader/CircleLoader';
import TimeAgo from '../../../Util/TimeAgo/TimeAgo';

@observer class Card extends Component<any, any> {

	@observable lastComment?: any;
	@observable fetched: boolean = false;

	componentDidMount() {
		Request.get('/questions/' + this.props.question.id + '/comments?orderBy[createdAt]=DESC&limit=1', {}).then((response) => {
			if (!response.status) {
				this.fetched = true;
				if(response.length > 0) {
					this.lastComment = response[0];
				}
			}
		});
	}

	componentDidUpdate() {
		if (this.props.lastComment) {
			if (this.props.lastComment === 'empty') {
				this.lastComment = null;
			} else {
				this.lastComment = this.props.lastComment;
			}
		}
	}

	render() {
		return (
			<Link to={'/question/' + this.props.question.id} className="question-card">
				<div className="question-side-info">
					<p>
						<b title={this.props.question.question_options[0].name}>
							{this.props.question.question_options[0].name.slice(0, 10)}{this.props.question.question_options[0].name.length > 9 ? '... ' : ' '} 
						</b> 
						{this.props.question.question_options[0].votes ? this.props.question.question_options[0].votes : 0}
					</p>
					<p><b>vs</b></p>
					<p>
						<b title={this.props.question.question_options[1].name}>
							{this.props.question.question_options[1].name.slice(0, 10)}{this.props.question.question_options[1].name.length > 9 ? '... ' : ' '} 
						</b> 
						{this.props.question.question_options[1].votes ? this.props.question.question_options[1].votes : 0}
					</p>
				</div>
				<div className="question-card-info">
					<h2>{this.props.question.name}</h2>
					<p>created by {this.props.question.user.username} <TimeAgo date={this.props.question.created_at} /></p>
				</div>
				{this.lastComment ? 
					(
						<div className="question-last-comment">
							<h3>Last Comment on "{this.lastComment.question_option.name}"</h3>
							<p>from {this.lastComment.user.username} <TimeAgo date={this.lastComment.created_at} /></p>
							<p className="last-comment-content">{this.lastComment.content.slice(0, 100)}{this.lastComment.content.length > 99 ? '...' : null}</p>
						</div>
					)
					: 
					(
						<div className="question-last-comment no-comment-found">
							{!this.fetched ? <CircleLoader size={20} color='#D9D9D9' /> : (<h3>No comments yet!</h3>)}
						</div>
					)
				}
			
			</Link>
		)
	}
}

export default Card;

